import React, { useEffect, useState } from "react";
import InfoIcon from "../../shared-components/icons/InfoIcon";
import { useSubscriptionContext } from "./subscriptionContext";

export default function PaymentProcessingModal({ onComplete }: { onComplete?: () => void }) {
  const [counter, setCounter] = useState(5);
  const { setIsInvoiceProcessing } = useSubscriptionContext();

  useEffect(() => {
    if (counter === 0) {
      setIsInvoiceProcessing?.(false);
      if (onComplete) {
        onComplete();
      } else {
        location.href = "/";
      }
      return;
    }

    const timer = setTimeout(() => {
      setCounter(prev => prev - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [counter, setIsInvoiceProcessing, onComplete]);

  return (
    <>
      <div>
        <div data-name="Overlay" className="!fixed !inset-0 z-[9999] bg-black/80" />
        <div
          data-name="PopupContainer"
          className={"fixed inset-0 z-[99999] w-full min-h-full overflow-x-hidden overflow-y-auto"}>
          <div className={"w-full min-h-full flex items-center justify-center flex-col m-auto p-4"}>
            <div className={"bg-white relative w-full lg:max-w-[480px] px-4 py-6 lg:px-7.5 flex flex-col rounded-2xl"}>
              <div className={"flex items-center justify-center mb-4"}>
                <InfoIcon className={"size-10 shrink-0 text-gray-1"} variant={2} />
              </div>
              <div className="text-center font-jost text-sm font-normal lg:text-base mb-4">
                Your payment is being processed. Please allow a few minutes for your past invoices to update.
              </div>
              <div className="text-center font-jost text-sm font-normal lg:text-base">
                You'll be redirected to the home page in{" "}
                <span className={"text-secondary font-semibold"}>{counter}</span>s
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
